import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import SalaHero from './Components/Hero';
import SalaAbout from './Components/About';
import SalaAdertise from './Components/SalaAdertise';
import Features from './Components/Features';
import BuyVilla from './Components/BuyVilla';
import SalaGallery from './Components/SalaGallery';
import { Salavdo } from './Components/Salavdo';
import SalaContact from './Components/Contact';
import SalaFooter from './Components/Footer';
import BrochureBadge from './Components/BrochureBadge';
import { initTracking } from './utils/Tracking';

function App() {
  useEffect(() => {
    initTracking();
  }, []); return (

    <div className="App">
      <BrochureBadge />
      <SalaHero />
      <Features />
      <SalaAdertise />
      <SalaAbout />
      <BuyVilla />
      <SalaGallery />
      <Salavdo />
      <SalaContact />
      <SalaFooter />
    </div>
  );
}

export default App;

